import * as React from "react";
import {Navigate, useLocation} from "react-router";
import ApiHelper from "@/helpers/ApiHelper";

export const userStructure = {
    id: null,
    name: null,
    email: null,
    type: null,
    organization: {id: null, name: null, access_level: null},
};

const AuthContext = React.createContext({
    user: null,
    setUser: () => {},
    loading: true,
    login: () => {},
    logout: () => {},
    updateUser: () => {},
    loginPath: "/auth/login",
});

export function AuthProvider({children}) {
    const [user, setUser] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        if (typeof window === "undefined") {
            setLoading(false);
            return;
        }

        const api = new ApiHelper();
        api.getRequest('/auth/me')
            .then((response) => {
                if (response?.data?.success && response.data.data) {
                    setUser(response.data.data);
                }
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const login = React.useCallback((userData) => {
        setUser(userData);
    }, []);

    const logout = React.useCallback(() => {
        setUser(null);
    }, []);

    const updateUser = React.useCallback((newUserData) => {
        setUser((prev) => ({...prev, ...newUserData}));
    }, []);

    const value = React.useMemo(
        () => ({user, setUser, loading, login, logout, updateUser, loginPath: "/auth/login"}),
        [user, loading, login, logout, updateUser]
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    return React.useContext(AuthContext);
}

export function RequireAuth({children}) {
    const {user, loading, loginPath} = useAuth();
    const location = useLocation();

    if (loading) {
        return null;
    }

    if (!user) {
        return <Navigate to={loginPath} state={{from: location}} replace />;
    }

    return children;
}

export function RequireProject({children}) {
    return children;
}
